import React from 'react';
import {useStyles} from "../DeliveryPerson.style";
import clsx from "clsx";
import DeliveryPersonRowProperties from "./DeliveryPersonRowProperties";
import ShowSellerBasicInfo from "../../../shared_components/Info/ShowSellerBasicInfo/ShowSellerBasicInfo";
import AllowAccess from '../../../shared_components/Access/AllowAccess/AllowAccess';
import ShowBalances from '../../../shared_components/Info/ShowBalances/ShowBalances';
import ShowDeliveryPersonArticleStock from '../../../shared_components/Info/ShowDeliveryPersonArticleStock/ShowDeliveryPersonArticleStock';
import Access from '../../../shared_components/Access/AllowAccess/Access';
import ExpandoMenu from '../../../ui_components/ExpandoMenu/ExpandoMenu';
import NewDeliveryPersonButton from '../../../shared_components/Buttons/NewDeliveryPersonButton/NewDeliveryPersonButton';
import AddBalanceButton from '../../../shared_components/Buttons/AddBalanceButton/AddBalanceButton';
import DeliveryCostButton from '../../../shared_components/Buttons/DeliveryCostButton/DeliveryCostButton';
import RemoveDeliveryPersonButton from '../../../shared_components/Buttons/RemoveDeliveryPersonButton/RemoveDeliveryPersonButton';
import UpdateDeliveryPersonPasswordButton from '../../../shared_components/Buttons/UpdateDeliveryPersonPasswordButton/UpdateDeliveryPersonPasswordButton';
import ViewTransactionsButton from '../../../shared_components/Buttons/ViewTransactionsButton/ViewTransactionsButton';
import ButtonSize from '../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../ui_components/Button/ButtonType';


const DeliveryPersonRowSmall: React.FC<DeliveryPersonRowProperties> = ({person, onUpdate}) => {

    const classes = useStyles();


    return (
        <div className={clsx(classes.client_info_container_small)}>
            <div className={classes.name_menu_small_container}>
                <ShowSellerBasicInfo autofill name={person.name} phone={person.phone}/>
                <ExpandoMenu>
                    <>
                        <NewDeliveryPersonButton
                            type={ButtonType.SECONDARY}
                            onSave={onUpdate}
                            deliveryPersonId={person.id}
                            size={ButtonSize.SMALL}
                            showText
                        />
                        <DeliveryCostButton
                            type={ButtonType.SECONDARY}
                            size={ButtonSize.SMALL}
                            onClose={onUpdate}
                            showText
                            deliveryPerson={person}
                        />
                        <AddBalanceButton
                            type={ButtonType.SECONDARY}
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            showText
                            entityName={person.name}
                            entityId={person.id}
                        />
                        <ViewTransactionsButton
                            type={ButtonType.SECONDARY}
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            showText
                            entityId={person.id}
                        />
                        <RemoveDeliveryPersonButton
                            type={ButtonType.SECONDARY}
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            showText
                            deliveryPerson={person}
                        />
                        <UpdateDeliveryPersonPasswordButton
                            type={ButtonType.SECONDARY}
                            size={ButtonSize.SMALL}
                            deliveryPersonId={person.id}
                            deliveryPersonName={person.name}
                        />
                    </>
                </ExpandoMenu>
            </div>
            <AllowAccess any={[Access.GET_BALANCE_OF_DELIVERY_PERSON, Access.GET_ARTICLE_STOCK_OF_DELIVERY_PERSON]}>
                <div className={classes.balances_container_small}>
                    <AllowAccess any={[Access.GET_BALANCE_OF_DELIVERY_PERSON]}>
                        <ShowBalances label={'Saldos'} balances={person.balances} activeMoneyDeliveryBalances={person.activeMoneyDeliveryBalances}/>
                    </AllowAccess>
                    <AllowAccess any={[Access.GET_ARTICLE_STOCK_OF_DELIVERY_PERSON]}>
                        <ShowDeliveryPersonArticleStock deliveryPerson={person} onClose={onUpdate}/>
                    </AllowAccess>
                </div>
            </AllowAccess>
        </div>
    )
}

export default DeliveryPersonRowSmall;
